import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-secondary-600 md:text-sm">
      <Link to="/" className="flex cursor-pointer items-center gap-1 transition-colors hover:text-primary-700">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-secondary-400"></i>
          {item.to ? (
            <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-700">
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}